<template>
  <base-dialog-form
    ref="listLocationDialog"
    :title="$t('sport_facilities')+' '+asdCode"
    color="secondary"
    icon="mdi-earth"
  >
    <DataTables :headers="headers" :tableData="tableData"></DataTables>
  </base-dialog-form>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  name: "list-ente-impianti",
  components: {
    DataTables,
  },

  data() {
    return {
      asdCode: null,
      headers: [
        { text: this.$t("image"), value: "image", type: "image" },
        { text: this.$t("name"), value: "nome" },
        { text: this.$t("nation"), value: "codiPai" },
      ],
      tableData: [],
    };
  },
  methods: {
    open(asdCode) {
      this.asdCode = asdCode;
      this.loadTable();
      this.$refs.listLocationDialog.open();
    },
    loadTable() {
      let _ = this;
      _.tableData = [];
      this.chiamataAxios("GET", "/auth/ente/listImpianti/" + _.asdCode).then(
        (response) => {
          // Aggiunge actions e icona validazione
          _.tableData = response.data.locations;
        }
      );
    },
  },
};
</script>